var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArrowLeft = function SvgArrowLeft(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#1B1B1B",
    fillRule: "evenodd",
    d: "M17.707 6.293a1 1 0 0 1 0 1.414L11.414 14l6.293 6.293a1 1 0 0 1-1.414 1.414L8.586 14l7.707-7.707a1 1 0 0 1 1.414 0",
    clipRule: "evenodd"
  })));
};
export default SvgArrowLeft;